
import request from '@/utils/request'

export function getAgencyInformation(params) {
    return request({
        url: '/agent_admin/agency/queryAgency',
        method: 'get',
        params
    })
}

export function getDailyReport(data) {
    return request({
        url: '/agent_admin/dashboard/daily/list',
        method: 'post',
        data
    })
}

export function getAgencyregister(params) {
    return request({
        url: '/agent_admin/agent/register',
        method: 'get',
        params
    })
}


